import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconModeDark(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M12 20.963c-2.517 0-4.646-.87-6.388-2.612C3.871 16.609 3 14.48 3 11.963c0-2.3.75-4.295 2.25-5.987 1.5-1.692 3.417-2.68 5.75-2.963a.883.883 0 0 1 .575.088c.167.091.3.212.4.362.1.15.154.325.162.525a.897.897 0 0 1-.187.575 5.15 5.15 0 0 0-.637 1.375 5.394 5.394 0 0 0-.213 1.525c0 1.5.525 2.775 1.575 3.825 1.05 1.05 2.325 1.575 3.825 1.575.517 0 1.03-.075 1.538-.225.508-.15.962-.358 1.362-.625a.956.956 0 0 1 .563-.162c.191.008.362.054.512.137a.887.887 0 0 1 .387.375c.092.167.121.367.088.6-.233 2.3-1.212 4.209-2.938 5.725-1.724 1.517-3.729 2.275-6.012 2.275Zm0-2c1.467 0 2.783-.404 3.95-1.212a7.012 7.012 0 0 0 2.55-3.163c-.333.084-.667.15-1 .2-.333.05-.667.075-1 .075-2.05 0-3.796-.72-5.238-2.162C9.821 11.259 9.1 9.513 9.1 7.463c0-.333.025-.666.075-1 .05-.333.117-.666.2-1a7.013 7.013 0 0 0-3.162 2.55C5.404 9.18 5 10.497 5 11.963c0 1.934.683 3.584 2.05 4.95 1.367 1.367 3.017 2.05 4.95 2.05Z"
      />
    </BaseIcon>
  );
}
